import styled from "styled-components";
import {
  Typography as MuiTypography,
  Box as MuiBox,
} from "@mui/material";

export {
  Container,
  Box,
  SecondBox,
} from "../Templates/styles";

// AI Review는 컬럼 수가 많아 공용 Wrap(고정 1568px)으로는 좁아 폭을 넓힌다.
export const Wrap = styled(MuiBox)`
  &.MuiBox-root {
    width: 1640px;
  }
  outline: none;
`;

export const SecondContainer = styled(MuiBox)`
  &.MuiBox-root {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    /* height 고정이면 요약 줄이 wrap 됐을 때 늘어난 내용이 밖으로 넘친다.
       min-height 로 두어 줄이 늘면 컨테이너도 같이 늘어나게 한다. */
    min-height: 60px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
  }
`;

export const ThirdBox = styled(MuiBox)`
  &.MuiBox-root {
    /* 고정 height 면 요약 줄이 wrap 됐을 때 넘친 줄이 아래 줄과 겹친다. */
    min-height: 20px;
    display: flex;
    align-items: center;
    gap: 2px;
  }
`;

export const Typography = styled(MuiTypography)`
  &.MuiTypography-root {
    /* flex-direction / justify-content 는 두지 않는다.
       이 컴포넌트는 보통 display:block 인 <p> 라 예전엔 무해했지만,
       요약 줄의 값 자리처럼 display:inline-flex 를 주는 순간 살아나
       내용(별 아이콘 등)을 세로로 쌓아버린다.
       &.MuiTypography-root 가 sx 보다 특이도가 높아 호출부에서 못 덮는다. */
    font-size: 14px;
    text-overflow: ellipsis;
  }
`;
